<template>
<div class="main">
	<Steps :index="0" :product-name="productName" />
	<!-- 大地低职业基本信息M1 -->
	<template v-if="info.productCode=='CCIC_EMPLOYER_LIABILITY_M1'">
		<ApplicantCcic_M1 :info="info.applicantList[0]" :amount="amount" @on-change="setApplicantData" @getInvoice="getInvoice" @on-checkBlacklistchange="checkBlacklistchange" ref="applicant" title="投保企业信息"/>
		<InsuredPerson :info="info" ref="insuredPerson" @on-change="setInsuredPersonData"/>
		<RecognizeCcic_M1 ref="recognize" :info="info" @set-amount="setAmount"/>
	</template>
	<!-- 大地低职业基本信息 M2-->
	<template v-else-if="info.productCode=='CCIC_EMPLOYER_LIABILITY_M2'">
		<ApplicantCcic_M2 :info="info.applicantList[0]" :amount="amount" @on-change="setApplicantData" @getInvoice="getInvoice" @on-checkBlacklistchange="checkBlacklistchange" ref="applicant" title="投保企业信息"/>
		<RecognizeCcic_M2  ref="recognize" :info="info" @set-amount="setAmount"/>
	</template>

	<Invoice :info="info.invoiceInfo" ref="invoice" class="mt20"/>
	<div class="mt20 center">
        <p class="agree">总费用：<span class="price">{{amount}}元</span></p>
        <p class="mt10">
            <Button type="primary" @click="sub" :disabled="blackListShow" :loading="loading">立即投保</Button>
        </p>
    </div>
	<div class="mt15 center">
        <a :loading="loadingTs" @click="draftClick" class="draft">暂存</a>
    </div>
	<TrackNotice v-if="id&&$route.query.reset" />
</div>
</template>
<script>
import Steps from './common/Steps'
import RecognizeCcic_M1 from './RecognizeCcic_M1'
import RecognizeCcic_M2 from './RecognizeCcic_M2'

import ApplicantCcic_M1 from './common/ApplicantCcic_M1'
import ApplicantCcic_M2 from './common/ApplicantCcic_M2'
import InsuredPerson from './common/InsuredPerson'

import TrackNotice from '@/components/common/TrackNotice.vue';
import Invoice from './common/Invoice'
import { mapState } from 'vuex'
import track from "@/mixin/track";
export default {
	mixins:[track],
	components:{ 
		Steps,
		Invoice,
		RecognizeCcic_M1,
		ApplicantCcic_M1,
		RecognizeCcic_M2,
		ApplicantCcic_M2,
		InsuredPerson,
		TrackNotice
	},
	data () {
		return {
			info:{
				insurancePeriod:'12',
				applicantList:[],
				insuredList:[],
				invoiceInfo:{
					invoiceType:'NOT',
				},
				subjectMatter:[],
				productCode:this.$route.query.productCode,
			},
			amount: null,
			loading:false,
			loadingTs:false,
			id:this.$route.params.id,
			insuranceType:this.$route.query.reset||'NEW', // 是否重新投保
			productName: this.$route.query.productName||'',
			blackListShow:false
		}
	},
	computed:{
		...mapState({
			userInfo:state=>state.common.info
		})
	},
	watch:{
		userInfo(){
			this.checkLogin()
		}
	},
	created () {
		if(this.checkLogin&&this.id&&this.insuranceType=='NEW'&&!this.$route.query.reset){
			this.getInfo()
		}
		if(this.checkLogin&&this.id&&this.$route.query.reset){
			this.getOrderInfo(); 
		}
	},
	mounted(){
		// 重新投保
		if(this.id&&this.$route.query.reset){
			this.track_is_new = true;
			this.$nextTick(()=>{
				this.trackInit();
			})
		} else {
			// 回溯 开始录制
			this.$nextTick(this.startRecord);
		}
	},
	methods:{
		// 黑名单校验
		checkBlacklistchange(form){
			this.checkBlacklist(form).then(res=>{
				if(res.code==10000000){
					this.blackListShow = false;
				}
			}).catch(err=>{
				this.blackListShow = true;
			});
		},
		getInvoice(code){
			this.$axios.post('/broker/insurance/application/findInvoiceInfo.json.all',{
				invoiceUniqueCode:code
			}).then(res=>{
				if(res.data){
					this.info.invoiceInfo = res.data
				}else{
					this.info.invoiceInfo = {
						invoiceType:'NOT'
					}
		        }
			})
		},
		// 暂存
		async draftClick(){
			let applicant = await this.$refs.applicant.drafts();
			let insuredPerson = await this.$refs.insuredPerson.drafts();
			let recognize = await this.$refs.recognize.drafts();
			let invoice = await this.$refs.invoice.drafts();
			recognize.employerTotalAmountVO.productCode = this.info.productCode;
			let form = {}
			form = {
				...this.info,
				applicantList:[{
					...applicant,
					subjectType:'APPLICANT'
				}],
				insuredList: insuredPerson.insuredList || [],
				...recognize.employerTotalAmountVO,
				bizId:'INDUSTRY_ENTERPRISE',
				subjectMatter:recognize.importEmployeeVOS,
				insuranceType:this.insuranceType,
				invoiceInfo:invoice,
				dictVersion: this.$route.query.version?this.$route.query.version:this.info.dictVersion
			}
			this.loadingTs = true;
		    this.$axios.post('/broker/insurance/application/draft.json.all',form).then(async res=>{
				this.loadingTs = false;
				if(res.code==10000000){
					// 回溯 停止录制
					await this.stopRecord({
						session_key:sessionStorage.track_session_key,
						policy_id:res.msg||''
					});
					this.$Message.success('暂存成功')
					this.$nextTick(()=>{
						this.id = res.data;
						this.getInfo()
					})
					this.$router.replace(`/companyGroupEmployerDadi/fillin/${res.data}?productCode=${this.info.productCode}`)
				}else{
		            this.alert(res.msg)
		        }
			}).catch(err=>{
				this.loadingTs = false;
			})
		},
		getPremium(){
			this.$refs.recognize.getPremium();
		},
		checkLogin(){
			// 检测登录
			if(!this.userInfo.userId){
				if(location.href&&location.href.indexOf('/common.html#/login')==-1){
					window.location = location.origin +'/common.html#/login?bankUrl='+encodeURIComponent(location.href);
				}
				return false
			}else{
				return true
			}
		},
		// 根据id获取信息
		getInfo(){
			this.$axios.post('/broker/insurance/application/detail.dst',{
				applicationId:this.id
			}).then(async res=>{
				if(res.effectiveDateStart){
					// 续保
					res.effectiveDateStart='';
					res.effectiveDateEnd='';
					this.$refs.recognize.setStartTimeOption()
				}
				this.info = res;
				// this.$refs.recognize.list = res.subjectMatter;
				// this.applicantList = res.applicantList[0]
				this.$set(this.info,'invoiceInfo',{
					...res.applicantList[0],
					...res.invoiceInfo
				})
				this.$forceUpdate()
			});
		},
		// 根据单号获取信息
		async getOrderInfo (){
			this.$axios.post('/broker/insurance/application/detailByApplicationNo.dst',{
				applicationNo:this.id
			}).then(async res=>{
				if(this.$route.query.reset){
					// 续保
					res.effectiveDateStart='';
					res.effectiveDateEnd='';
					this.$refs.recognize.setStartTimeOption()
				}
				this.info = res;
				this.$set(this.info,'invoiceInfo',{
					...res.applicantList[0],
					...res.invoiceInfo
				})
				this.$forceUpdate()
			});
		},
		// 校验
		async sub () {
			let applicant = await this.$refs.applicant.val();
			let insuredPerson = await this.$refs.insuredPerson.val();
			let recognize = await this.$refs.recognize.val();
			let invoice = await this.$refs.invoice.val();
			console.log(applicant,insuredPerson,recognize,invoice,'000000000000000000')
			if(!applicant){
			    this.toast('投保企业信息校验失败','error');
			    return;
			}
			if(!insuredPerson){
			    this.toast('被保险人信息校验失败','error');
			    return;
			}
			if(!recognize){
				return;
			}
			if(!invoice){
			    this.toast('发票信息校验失败','error');
			    return;
			}
			if(this.$route.query.reset){
				this.$delete(applicant,'id')
				recognize.importEmployeeVOS.forEach((item)=>{ 
					if (item.id){   
						delete  item.id;  
					}
				})
			}
			this.loading = true;
			recognize.employerTotalAmountVO.productCode = this.info.productCode;
			let form = {}
			form = {
				applicantList:[{
					...applicant,
					subjectType:'APPLICANT'
				}],
				insuredList: insuredPerson.insuredList || [],
				...recognize.employerTotalAmountVO,
				bizId:'INDUSTRY_ENTERPRISE',
				// employerTotalAmountVO:recognize.employerTotalAmountVO,
				subjectMatter:recognize.importEmployeeVOS,
				insuranceType:this.insuranceType,
				invoiceInfo:invoice,
				insuranceApplicationId:this.$route.query.reset?null:(this.info.insuranceApplicationId||null),
				dictVersion: this.$route.query.version?this.$route.query.version:this.info.dictVersion
			}
		    this.$axios.post('/broker/insurance/application/apply.json.all',form).then(async res=>{
				this.loading = false;
				if(res.code==10000000){
					// 回溯 停止录制
					await this.stopRecord({
						session_key:sessionStorage.track_session_key,
						policy_id:res.msg
					});
					if(!this.id||res.data!=this.id){
						this.$router.push(`/companyGroupEmployerDadi/fillin/${res.data}?productCode=${this.info.productCode}`)
					}
					this.$router.push('/companyGroupEmployerDadi/confirm/'+res.data);
				}else{
		            this.alert(res.msg)
		        }
			}).catch(err=>{
				this.loading = false;
			});
		},
		// 设置总费用
		setAmount(amount) {
			this.amount=amount;
		},
		// 设置产品code
		setProductCode(productCode) {
			this.info.productCode = productCode;
		},
		setExtraInfo(info){
			this.$set(this.info,'extraInfo',info)
		},
		// 同步投保公司数据，用于更新公司名称和社会代码，开票组件会用到
		setApplicantData(form) {
			this.$set(this.info,'invoiceInfo',{
				...this.info.invoiceInfo,
				...form
			})
		},
		// 同步被保险人数据
		setInsuredPersonData(data) {
			this.$set(this.info, 'insuredList', data.insuredList || [])
		}
	}
}
</script>
<style scoped lang="less">
	.draft{
		font-size: 18px;
		font-weight: bold;
	}
	.main{
		margin-top: 24px;
		padding :30px 40px;
	}
	.mt20{
	    // font-size: 25px;
	    line-height: 1.8;
	}
	span.price{
	    color:#FF0000;
	    font-weight: bold;
	}
	.text{
		font-size: 16px;
		color: red;
	}
</style>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerDadi/Fillin.vue